// extracted by mini-css-extract-plugin
export default {"LinkTo":"styles_LinkTo__+Zr10","text":"styles_text__8mOjR","variantSquare":"styles_variantSquare__M8M4u","icon":"styles_icon__xYd4C","variantWide":"styles_variantWide__uaJw2"};